/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BankDetailsExtractionResult,
  DocumentMinimalDto,
  ErrorResponse,
  FileTypeEnum,
  GetDocumentViewItemsResponse,
  GetDocuments404Response,
  GetDocumentsContractuelsProduitResponse,
  GetGenericListCommandDto,
  GetProductDocumentResponse,
  GetSimulationDocumentsResponseDto,
  IdentityVerifyCommand,
  OperationResponse,
  SimulationDocumentDto,
  SupportTypeEnum,
} from '../models/index';
import {
    BankDetailsExtractionResultFromJSON,
    BankDetailsExtractionResultToJSON,
    DocumentMinimalDtoFromJSON,
    DocumentMinimalDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FileTypeEnumFromJSON,
    FileTypeEnumToJSON,
    GetDocumentViewItemsResponseFromJSON,
    GetDocumentViewItemsResponseToJSON,
    GetDocuments404ResponseFromJSON,
    GetDocuments404ResponseToJSON,
    GetDocumentsContractuelsProduitResponseFromJSON,
    GetDocumentsContractuelsProduitResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetProductDocumentResponseFromJSON,
    GetProductDocumentResponseToJSON,
    GetSimulationDocumentsResponseDtoFromJSON,
    GetSimulationDocumentsResponseDtoToJSON,
    IdentityVerifyCommandFromJSON,
    IdentityVerifyCommandToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SimulationDocumentDtoFromJSON,
    SimulationDocumentDtoToJSON,
    SupportTypeEnumFromJSON,
    SupportTypeEnumToJSON,
} from '../models/index';

export interface CreateProductDocumentRequest {
    productId: string;
    supportType: SupportTypeEnum;
    fileType: FileTypeEnum;
    file: Blob;
}

export interface ExtractIbanFromRibRequest {
    storedFileId: string;
}

export interface ExtractNamesFromIdentityRequest {
    storedFileId: string;
    naturalPersonId: string;
}

export interface GetContractDocumentByFileTypeRequest {
    contractId: string;
    fileType: number;
}

export interface GetDocumentsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetProductContractualDocumentsRequest {
    produitId: string;
}

export interface GetProductDocumentsRequest {
    productId: string;
}

export interface GetSimulationDocumentsByProductIdRequest {
    productId: string;
    fileType: number;
}

export interface GetSimulationDocumentsByQuoteIDRequest {
    quoteId: string;
}

export interface VerifyIdentityNamesRequest {
    identityVerifyCommand: IdentityVerifyCommand;
}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI {

    /**
     * Create product documents by fileType
     */
    async createProductDocumentRaw(requestParameters: CreateProductDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling createProductDocument().'
            );
        }

        if (requestParameters['supportType'] == null) {
            throw new runtime.RequiredError(
                'supportType',
                'Required parameter "supportType" was null or undefined when calling createProductDocument().'
            );
        }

        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling createProductDocument().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling createProductDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/backoffice/documents-produits/produits/{productId}/supports/{supportType}/types/{fileType}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))).replace(`{${"supportType"}}`, encodeURIComponent(String(requestParameters['supportType']))).replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create product documents by fileType
     */
    async createProductDocument(requestParameters: CreateProductDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createProductDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Extracts IBAN and BIC from a RIB document (PDF/image) using OCR
     * Extract IBAN from RIB document
     */
    async extractIbanFromRibRaw(requestParameters: ExtractIbanFromRibRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankDetailsExtractionResult>> {
        if (requestParameters['storedFileId'] == null) {
            throw new runtime.RequiredError(
                'storedFileId',
                'Required parameter "storedFileId" was null or undefined when calling extractIbanFromRib().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['storedFileId'] != null) {
            queryParameters['storedFileId'] = requestParameters['storedFileId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/documents/rib/extract-iban`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BankDetailsExtractionResultFromJSON(jsonValue));
    }

    /**
     * Extracts IBAN and BIC from a RIB document (PDF/image) using OCR
     * Extract IBAN from RIB document
     */
    async extractIbanFromRib(requestParameters: ExtractIbanFromRibRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankDetailsExtractionResult> {
        const response = await this.extractIbanFromRibRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Runs OCR on a previously uploaded identity document and compares the extracted first/last name with the person stored under naturalPersonId in DB. Returns a generic OperationResponse: isSuccess=true when OCR succeeded and names match the person; isSuccess=false otherwise (OCR failed or mismatch) — the front falls back to manual entry. 
     * Verify identity document via OCR
     */
    async extractNamesFromIdentityRaw(requestParameters: ExtractNamesFromIdentityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['storedFileId'] == null) {
            throw new runtime.RequiredError(
                'storedFileId',
                'Required parameter "storedFileId" was null or undefined when calling extractNamesFromIdentity().'
            );
        }

        if (requestParameters['naturalPersonId'] == null) {
            throw new runtime.RequiredError(
                'naturalPersonId',
                'Required parameter "naturalPersonId" was null or undefined when calling extractNamesFromIdentity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['storedFileId'] != null) {
            queryParameters['storedFileId'] = requestParameters['storedFileId'];
        }

        if (requestParameters['naturalPersonId'] != null) {
            queryParameters['naturalPersonId'] = requestParameters['naturalPersonId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/identity-verification/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Runs OCR on a previously uploaded identity document and compares the extracted first/last name with the person stored under naturalPersonId in DB. Returns a generic OperationResponse: isSuccess=true when OCR succeeded and names match the person; isSuccess=false otherwise (OCR failed or mismatch) — the front falls back to manual entry. 
     * Verify identity document via OCR
     */
    async extractNamesFromIdentity(requestParameters: ExtractNamesFromIdentityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.extractNamesFromIdentityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve simulation documents by Quote ID
     */
    async getContractDocumentByFileTypeRaw(requestParameters: GetContractDocumentByFileTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentMinimalDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getContractDocumentByFileType().'
            );
        }

        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling getContractDocumentByFileType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/documents/contrat/{contractId}/type/{fileType}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))).replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentMinimalDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve simulation documents by Quote ID
     */
    async getContractDocumentByFileType(requestParameters: GetContractDocumentByFileTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentMinimalDto> {
        const response = await this.getContractDocumentByFileTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Documents List
     */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentViewItemsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/documents/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentViewItemsResponseFromJSON(jsonValue));
    }

    /**
     * Get Documents List
     */
    async getDocuments(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentViewItemsResponse> {
        const response = await this.getDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the active contractual documents of a product (general and special conditions, notice, IPID, product sheet)
     */
    async getProductContractualDocumentsRaw(requestParameters: GetProductContractualDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentsContractuelsProduitResponse>> {
        if (requestParameters['produitId'] == null) {
            throw new runtime.RequiredError(
                'produitId',
                'Required parameter "produitId" was null or undefined when calling getProductContractualDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/documents/produits/{produitId}/contractuels`.replace(`{${"produitId"}}`, encodeURIComponent(String(requestParameters['produitId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentsContractuelsProduitResponseFromJSON(jsonValue));
    }

    /**
     * List the active contractual documents of a product (general and special conditions, notice, IPID, product sheet)
     */
    async getProductContractualDocuments(requestParameters: GetProductContractualDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentsContractuelsProduitResponse> {
        const response = await this.getProductContractualDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve product documents by product ID
     */
    async getProductDocumentsRaw(requestParameters: GetProductDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProductDocumentResponse>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling getProductDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/documents-produits/produits/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProductDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve product documents by product ID
     */
    async getProductDocuments(requestParameters: GetProductDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProductDocumentResponse> {
        const response = await this.getProductDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve simulation documents by product ID
     */
    async getSimulationDocumentsByProductIdRaw(requestParameters: GetSimulationDocumentsByProductIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationDocumentDto>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling getSimulationDocumentsByProductId().'
            );
        }

        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling getSimulationDocumentsByProductId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/documents/produits/{productId}/fileTypes/{fileType}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))).replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimulationDocumentDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve simulation documents by product ID
     */
    async getSimulationDocumentsByProductId(requestParameters: GetSimulationDocumentsByProductIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationDocumentDto> {
        const response = await this.getSimulationDocumentsByProductIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve simulation documents by Quote ID
     */
    async getSimulationDocumentsByQuoteIDRaw(requestParameters: GetSimulationDocumentsByQuoteIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSimulationDocumentsResponseDto>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling getSimulationDocumentsByQuoteID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/documents/devis/{quoteId}`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSimulationDocumentsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve simulation documents by Quote ID
     */
    async getSimulationDocumentsByQuoteID(requestParameters: GetSimulationDocumentsByQuoteIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSimulationDocumentsResponseDto> {
        const response = await this.getSimulationDocumentsByQuoteIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Compares first/last name typed by the user against the person stored in DB. Used as a fallback when OCR failed or mismatched. Unlimited attempts. Returns a generic OperationResponse: isSuccess=true when the names match. 
     * Verify identity names manually
     */
    async verifyIdentityNamesRaw(requestParameters: VerifyIdentityNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['identityVerifyCommand'] == null) {
            throw new runtime.RequiredError(
                'identityVerifyCommand',
                'Required parameter "identityVerifyCommand" was null or undefined when calling verifyIdentityNames().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/identity-verification/verify/manual`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityVerifyCommandToJSON(requestParameters['identityVerifyCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Compares first/last name typed by the user against the person stored in DB. Used as a fallback when OCR failed or mismatched. Unlimited attempts. Returns a generic OperationResponse: isSuccess=true when the names match. 
     * Verify identity names manually
     */
    async verifyIdentityNames(requestParameters: VerifyIdentityNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.verifyIdentityNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
